import { toast } from "react-toastify";
import { Toast } from "../../../../config/Toast";
import Modal from "../../../../components/Modal";
import SalaryCalculationService from "../../../../services/SalaryCalculation";
import "react-toastify/dist/ReactToastify.css";

const DeleteModal = (props) => {
  const activeModal = props.activeModal ? "effect-scale show" : "";
  const activeStyle = activeModal ? { display: "block", paddingright: "17px" } : "";

  const notifySuccess = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);

  const submitHandler = () => {
    const id = props.dataModal.id;

    SalaryCalculationService.delete(id)
      .then(() => {
        props.setUpdate(true);
        props.closeModal();
        notifySuccess(`Tukang berhasil dihapus`);
      })
      .catch((err) => {
        console.log(err.response.data.message);
        notifyFailed(err.response.data.message);
        props.closeModal();
      });
  };

  return (
    <Modal
      activeModal={activeModal}
      activeStyle={activeStyle}
      title="Hapus Tukang"
      closeClick={props.closeModal}
      submitHandler={submitHandler}
      type="Delete"
    >
      <div className="flex flex-row justify-content-center align-items-center w-100">
        <div className="flex flex-row text-center w-80 flex-wrap justify-content-center align-items-center gap-2">
          <h5>Apakah anda yakin untuk menghapus tukang</h5>
          <h5 className="fw-bold">{props.dataModal.workerName}</h5> <h5>pada Project</h5>
          <h5 className="fw-bold">#{props.dataModal.projectId}</h5> <h5>?</h5>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
